// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1ap6c","buttons":"SendReceipts_buttons__3iqqN","email":"SendReceipts_email__3fI97","bookApptTitle":"SendReceipts_bookApptTitle__lzRNE"};